module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige1-c7e83358d222413fefff7a8908d6e07b.jpg";